module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesCreative.ac834ae.webp";